import { styled } from '@mui/material';
import type { CardContentProps } from '@mui/material/CardContent';
import MuiCardContent from '@mui/material/CardContent';
import { clsx } from 'clsx';
import type { FC } from 'react';

const StyledCardContent = styled(MuiCardContent)<CardContentProps>(({ theme }) => ({
  padding: theme.spacing(3),
  '+ .MuiCardActions-root': {
    marginTop: theme.spacing(-1),
    paddingTop: 0,
  },
}));

const CardContent: FC<CardContentProps> = ({ className, ...rest }) => {
  const classes = clsx('mnt-card-content', className);

  return <StyledCardContent {...rest} className={classes} />;
};
CardContent.displayName = 'CardContent';

export default CardContent;
export type { CardContentProps };
